export default {"src":"/_next/static/media/services-divider.54c9aa83.svg","height":552,"width":1281};